<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <div>
          <div class="w-full">
            <div
              slot="no-body"
              class="tabs-container inventory_tabSec"
              id="view-customer-tab"
            >
              <div class="mr-2 mb-1 order-1">
                <vs-table
                  :max-items="descriptionItems[0]"
                  pagination
                  :data="shiftsList || []"
                  description
                  search
                  :description-items="descriptionItems"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="header">
                    <div class="list-heading">
                      {{ $t("setup.label.ShiftManagement") }}
                    </div>
                    <div class="mr-2 mb-1 order-1" style="">
                      <vs-button
                        icon-pack="feather"
                        icon="icon-plus"
                        @click="$router.push({ name: 'Create Shift' })"
                        size="small"
                        color="primary"
                        >{{ $t("setup.label.CreateShift") }}</vs-button
                      >
                    </div>
                  </template>
                  <template slot="thead">
                    <vs-th>{{ $t("setup.label.Id") }}</vs-th>
                    <vs-th>{{ $t("setup.label.ShiftName") }}</vs-th>
                    <vs-th>{{ $t("setup.label.SessionType") }}</vs-th>
                    <vs-th>{{ $t("customers.label.created_date") }}</vs-th>
                    <vs-th>{{ $t("setup.label.StartTime") }}</vs-th>
                    <vs-th>{{ $t("setup.label.EndTime") }}</vs-th>
                    <vs-th class="tHeadCenter">{{
                      $t("setup.label.Actions")
                    }}</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="teamUser"
                      v-for="(teamUser, index) in data"
                    >
                      <vs-td :data="teamUser.id">{{ teamUser.configId }}</vs-td>
                      <vs-td :data="teamUser.name">{{ teamUser.name }}</vs-td>
                      <vs-td :data="teamUser.sessionType">{{
                        teamUser.sessionType
                      }}</vs-td>
                      <vs-td :data="teamUser.createdAt">{{
                        teamUser.createdAt ? getDate(teamUser.createdAt) : "-"
                      }}</vs-td>
                      <vs-td :data="teamUser.startTime">{{
                        teamUser.startTime
                      }}</vs-td>
                      <vs-td :data="teamUser.endTime">{{
                        teamUser.endTime
                      }}</vs-td>

                      <vs-td class="whitespace-no-wrap">
                        <div class="container_img">
                          <feather-icon
                            icon="EyeIcon"
                            title="View"
                            svgClasses="w-5 h-5 stroke-current cursor text-primary"
                            @click.stop="viewShift(teamUser.configId, teamUser.name)"
                            class="icon_row"
                          />
                          <feather-icon
                            icon="EditIcon"
                            title="edit"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="editShift(teamUser.name)"
                            class="icon_row"
                          />
                          <feather-icon
                            icon="TrashIcon"
                            title="Delete"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            @click.stop="
                              delId = teamUser.configId;
                              deleteShiftPopup = true;
                            "
                            class="icon_row"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
        <delete-popup
          :deletePopup="deleteShiftPopup"
          title="Shift"
          @deletePressed="deleteShift(delId)"
          @cancelPressed="deleteShiftPopup = false"
        >
        </delete-popup>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";
import moment from "moment";
import DeletePopup from "@/components/DeletePopup.vue";

export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      descriptionItems: [5, 10, 15],
      deleteShiftPopup: false,
      delId: 0,
      activeTab: 0,
      pages1: [
        { name: "Team", active: "active" },
        { name: "Team User", active: "inactive" },
      ],
    };
  },
  components: {
    AtomSpinner,
    "delete-popup": DeletePopup,
  },

  computed: {
    ...mapState({
      shiftsList: (state) => state.shiftManagement.shiftsList,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    viewShift(id, name) {
      this.$router.push({
        name: "View Shift",
        params: { id: id, name: name },
      });
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    async getShiftsListMethod() {
      this.loading = true;
      try {
        this.$store.dispatch("shiftManagement/getShiftsListAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteShift(id) {
      this.deleteShiftPopup = false;
      await this.$store.dispatch(
        "shiftManagement/deleteShiftAction",
        id
      );
      await this.getShiftsListMethod()
      this.$vs.notify({
        title: "Sucessfully deleted!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success",
      });
    },
    editShift(name) {
      this.$router.push({
        name: "Edit Shift",
        params: { name: name },
      });
    },
  },

  async mounted() {
    await this.getShiftsListMethod();
  },
};
</script>
<style scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow: hidden;
  background-color: rgba(var(--vs-primary), 1) !important;
  border-radius: 0.2rem;
}

li {
  float: left;
  font-weight: 550;
  font-size: 0.8rem;
  cursor: pointer;
}

li a {
  display: block;
  color: #fff;
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
  border: solid 0.2rem rgba(var(--vs-primary), 1);
}

li a:hover:not(.active) {
  border: solid 0.2rem rgba(var(--vs-primary), 1) !important ;
  background-color: #fff;
  color: rgba(var(--vs-primary), 1);
  box-shadow: rgba(var(--vs-primary), 1) 0px 7px 29px 0px;
}

.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}

.inventory_tabSec >>> .con-vs-tabs .con-ul-tabs {
  width: 40%;
  position: absolute;
  top: 1.3rem;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
</style>
